export const SearchRouteData = [
  {
    id: 1000,
    name: "enterRoute",
    placeholder: "Enter Route Here...",
    htmlElement: "string",
    dataType: "string",
    type: "input",
    required: true,
  }
]

export const TrafficUpdateData = [
  {
    id: 1004,
    location: {
      id: 1001,
      name: "trafficLocation",
      address: "Nyanya - Abuja",
      htmlElement: "string",
      dataType: "string",
      type: "text",
      required: true,
    },
    name: "update",
    status: "High",
    time: "10:00am",
    date: "06/10/2022",
    description: "Road Construction",
    updatedBy: "Uche Felix",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1005,
    location: {
        id: 1002,
        name: "trafficLocation",
        address: "Rumuigbo - PH",
        htmlElement: "string",
        dataType: "string",
        type: "text",
        required: true,
    },
    name: "update",
    status: "Low",
    time: "10:00am",
    date: "06/10/2022",
    description: "Road Construction",
    updatedBy: "Uche Felix",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1006,
    location: {
      id: 1003,
      name: "trafficLocation",
      address: "GSM Village - Lagos",
      htmlElement: "string",
      dataType: "string",
      type: "text",
      required: true,
    },
    name: "update",
    status: "High",
    time: "10:00am",
    date: "06/10/2022",
    description: "Road Construction",
    updatedBy: "Uche Felix",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1007,
    location: {
      id: 1004,
      name: "trafficLocation",
      address: "Ikorodu - Lagos",
      htmlElement: "string",
      dataType: "string",
      type: "text",
      required: true,
    },
    name: "update",
    status: "High",
    time: "11:45am",
    date: "06/10/2022",
    description: "Fuel Tanker Fall",
    updatedBy: "Kelina Oghene",
    htmlElement: "string",
    type: "text",
    required: true,
  },
  {
    id: 1008,
    location: {
        id: 1005,
        name: "trafficLocation",
        address: "Lugbe - Abuja",
        htmlElement: "string",
        dataType: "string",
        type: "text",
        required: true,
    },
    name: "update",
    status: "Medium",
    time: "07:30am",
    date: "19/01/2022",
    description: "Check Point",
    updatedBy: "Naza Agada",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1009,
    location: {
      id: 1006,
      name: "trafficLocation",
      address: "Lokoja - Kogi",
      htmlElement: "string",
      dataType: "string",
      type: "text",
      required: true,
    },
    name: "update",
    status: "Low",
    time: "10:00am",
    date: "11/10/2022",
    description: "Polical Rally",
    updatedBy: "Hajara Anthony",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1010,
    location: {
      id: 1007,
      name: "trafficLocation",
      address: "Bende - Abia",
      htmlElement: "string",
      dataType: "string",
      type: "text",
      required: true,
    },
    name: "update",
    status: "Low",
    time: "01:19pm",
    date: "19/11/2022",
    description: "Market",
    updatedBy: "Chinaturum Olisa",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1011,
    location: {
        id: 1008,
        name: "trafficLocation",
        address: "Chibok - Borno",
        htmlElement: "string",
        dataType: "string",
        type: "text",
        required: true,
    },
    name: "update",
    status: "Low",
    time: "06:51pm",
    date: "01/06/2022",
    description: "Flood",
    updatedBy: "Garba Abdul",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1012,
    location: {
      id: 1009,
      name: "trafficLocation",
      address: "Umuorji - Anambra",
      htmlElement: "string",
      dataType: "string",
      type: "text",
      required: true,
    },
    name: "update",
    status: "High",
    time: "12:10pm",
    date: "07/06/2022",
    description: "Station of the Cross",
    updatedBy: "Olaedo Eze",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1013,
    location: {
      id: 1010,
      name: "trafficLocation",
      address: "Surulere - Lagos",
      htmlElement: "string",
      dataType: "string",
      type: "text",
      required: true,
    },
    name: "update",
    status: "High",
    time: "08:19am",
    date: "11/07/2022",
    description: "Bad Road",
    updatedBy: "Adeola Latif",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1014,
    location: {
        id: 1011,
        name: "trafficLocation",
        address: "Uromi - Edo",
        htmlElement: "string",
        dataType: "string",
        type: "text",
        required: true,
    },
    name: "update",
    status: "Medium",
    time: "11:51am",
    date: "16/04/2022",
    description: "Road Construction",
    updatedBy: "Ehi Maxwell",
    htmlElement: "string",
    type: "text",
    required: true,
  },

  {
    id: 1015,
    location: {
      id: 1012,
      name: "trafficLocation",
      address: "Igbuzor - Delta",
      htmlElement: "string",
      dataType: "string",
      type: "text",
      required: true,
    },
    name: "update",
    status: "High",
    time: "10:00am",
    date: "02/09/2022",
    description: "Flood",
    updatedBy: "Blessing Mordi",
    htmlElement: "string",
    type: "text",
    required: true,
  },
]

export const SignupData = [
  {
    id: 1006,
    name: "fullName",
    label: "Full Name",
    placeholder: "Naza Anajemba",
    htmlElement: "string",
    dataType: "string",
    type: "input",
    required: true,
  },
  {
    id: 1007,
    name: "emailAddress",
    label: "Email Address",
    placeholder: "example@gmail.com",
    htmlElement: "string",
    dataType: "string",
    type: "input",
    required: true,
  },
  {
    id: 1008,
    name: "location",
    label: "Location",
    placeholder: "Mararaba, Kuje, Mile 1",
    htmlElement: "string",
    dataType: "string",
    type: "input",
    required: true,
  },
  {
    id: 1009,
    name: "password",
    label: "Password",
    placeholder: "e.g 123-a45Z6",
    htmlElement: "string",
    dataType: "string",
    type: "input",
    required: true,
  }
]

export const LoginData = [
  {
    id: 1010,
    name: "emailAddress",
    label: "Email Address",
    placeholder: "example@gmail.com",
    htmlElement: "string",
    dataType: "string",
    type: "input",
    required: true,
  },
  {
    id: 1011,
    name: "password",
    label: "Password",
    placeholder: "e.g 123-a45Z6",
    htmlElement: "string",
    dataType: "string",
    type: "input",
    required: true,
  }
]